var map = {
	"./120/CARDREADER_MANDATORY.svg": 80301,
	"./120/DEFAULT.svg": 75025,
	"./120/DISTRIBUTION_CARDREADER.svg": 72428,
	"./120/NFC.svg": 19873,
	"./120/POSTAL.svg": 67047,
	"./120/POSTALONPRODUCT.svg": 36597,
	"./120/REGULARIZATION.svg": 27422,
	"./120/VALIDATION_ERROR.svg": 24160,
	"./57/CARDREADER_MANDATORY.svg": 32948,
	"./57/DEFAULT.svg": 49430,
	"./57/DISTRIBUTION_CARDREADER.svg": 67595,
	"./57/NFC.svg": 37162,
	"./57/POSTAL.svg": 20146,
	"./57/REGULARIZATION.svg": 36003,
	"./57/VALIDATION_ERROR.svg": 65225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70520;